/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// var $tickerWrapper = $(".tickerwrapper");
// var $list = $tickerWrapper.find("ul.list");
// var $clonedList = $list.clone();
// var listWidth = 10;

// $list.find("li").each(function (i) {
// 			listWidth += $(this, i).outerWidth(true);
// });

// var endPos = $tickerWrapper.width() - listWidth;

// $list.add($clonedList).css({
// 	"width" : listWidth + "px"
// });

// $clonedList.addClass("cloned").appendTo($tickerWrapper);

// //TimelineMax
// var infinite = new TimelineMax({repeat: -1, paused: true});
// var time = 40;

// infinite
//   .fromTo($list, time, {rotation:0.01,x:0}, {force3D:true, x: -listWidth, ease: Linear.easeNone}, 0)
//   .fromTo($clonedList, time, {rotation:0.01, x:listWidth}, {force3D:true, x:0, ease: Linear.easeNone}, 0)
//   .set($list, {force3D:true, rotation:0.01, x: listWidth})
//   .to($clonedList, time, {force3D:true, rotation:0.01, x: -listWidth, ease: Linear.easeNone}, time)
//   .to($list, time, {force3D:true, rotation:0.01, x: 0, ease: Linear.easeNone}, time)
//   .progress(1).progress(0)
//   .play();

 
$('.shopify-policy__container').addClass('PageContent Rte');  
$('.shopify-policy__title').addClass('SectionHeader SectionHeader--center');  
$('.shopify-policy__title h1').addClass('SectionHeader__Heading Heading u-h1');  

 


 